<template>
    <div class="register">
        <h2>注册</h2>
        <div class="register-form">
            <mint-select selectLabel="所属服务点" selectPatch="station" :selectValue="station" :slots="stationSlots" @changeValue="changeValue"></mint-select>
            <mt-field label="用户名" placeholder="请输入用户名" v-model="username"></mt-field>
            <mt-field label="密码" placeholder="请输入密码" type="password" v-model="password"></mt-field>
            <mt-field label="重复密码" placeholder="请再输入一遍密码" type="password" v-model="rpassword"></mt-field>

            <mt-field label="姓名" placeholder="请输入姓名" v-model="name"></mt-field>
            <mt-field label="身份证号码" placeholder="请输入身份证号码" v-model="id_number"></mt-field>
            <mt-field label="联系电话" type="number" placeholder="请输入联系电话" v-model="phone"></mt-field>
            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="register()">申请注册</mt-button>
            </div>
            <div class="register-link">
                <router-link to="/login">我有账号，前去登录</router-link>
            </div>
        </div>
    </div>
</template>
<script>
    import mintSelect from '../components/mintSelect.vue'
    export default {
        components: {
            'mint-select':mintSelect
        },


        data(){
            return {
                station:'',
                stationSlots:[
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],
                name:'',
                phone:'',
                username:'',
                password:'',
                rpassword:'',
                id_number:'',
                openid:''
            }
        },

        methods:{
            register(){

                if(this.station===''||this.username===''||this.password===''||this.name===''||this.phone===''||this.id_number===''){
                    this.$toast({
                        message: '请完善信息',
                        position: 'top',
                        duration: 5000
                    });
                }else{

                    if(this.password!==this.rpassword){
                        this.$toast('两次密码输入不一致');
                        return false;
                    }

                    this.$indicator.open('注册中');

                    this.$axios.post("/register", {openid:this.openid,username:this.username,password:this.password,name:this.name,phone:this.phone,id_number:this.id_number,station:this.station})
                        .then(data => {

                            this.$indicator.close();

                            if (data.data.code === 'OK') {
                                this.$toast('申请成功！请等待审核!');
                            } else {
                                this.$toast(data.data.message);
                            }
                        });
                }

            },

            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            },
        },

        created(){

            this.$axios.get("/register")
                .then(data => {

                    this.$indicator.close();

                    if (data.data.code === 'OK') {
                        this.stationSlots[0].values = data.data.data;
                    } else {
                        this.$toast(data.data.message);
                    }
                });

            this.$axios.post("/oauth", {code: this.$route.query.code})
                .then(data => {

                    if (data.data.code === 'OK') {
                        this.openid = data.data.data;
                    } else {
                        this.$toast(data.data.message);
                    }
                });
        },
    }
</script>
<style>
    .register{
        padding:40px 25px;
    }
    .register h2{
        padding: 0 20px 10px 10px;
    }
    .register-link{
        text-align:center;
    }
    .register-link a{
        color:#888;
        text-decoration: none;
        font-size:14px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/register.vue